var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DefaultTemplate",
    [
      _c("UserInfo", {
        attrs: {
          id: "anchor",
          user: _vm.user,
          profile: _vm.isProfilePage,
          publicAlbums: _vm.publicAlbums,
          privateAlbums: _vm.privateAlbums,
          nftCollections: _vm.nftCollections
        },
        on: { userDataUpdate: _vm.getUser }
      }),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      !_vm.isLoaded ? _c("PreloaderComponent") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }